export enum GetUserActionTypes {
  OPEN_GET_USER_MODAL = 'OPEN_GET_USER_MODAL',
  CLOSE_GET_USER_MODAL = 'CLOSE_GET_USER_MODAL',
  GET_USER_REQUEST = 'GET_USER_REQUEST',
  GET_USER_SECCEEDED = 'GET_USER_SECCEEDED',
  GET_USER_FAILED = 'GET_USER_FAILED',
}

export interface User {
  id: string;
  username: string;
  email: string;
  avatar: string;
  groupName: number;
  joinDate: number;
  status: any;
  phoneNumber: string;
  point: number;
  __typename: any;
}

export interface OpenGetUserModal {
  type: GetUserActionTypes.OPEN_GET_USER_MODAL;
}

export interface CloseGetUserModal {
  type: GetUserActionTypes.CLOSE_GET_USER_MODAL;
}

export interface GetUserRequest {
  type: GetUserActionTypes.GET_USER_REQUEST;
  input: object;
}

export interface GetUserSucceeded {
  type: GetUserActionTypes.GET_USER_SECCEEDED;
  user: User;
}

export interface GetUserFailed {
  type: GetUserActionTypes.GET_USER_FAILED;
  error;
}

export type GetUserActions = OpenGetUserModal | CloseGetUserModal | GetUserRequest | GetUserSucceeded | GetUserFailed;

export function openGetUserModal(): OpenGetUserModal {
  return {
    type: GetUserActionTypes.OPEN_GET_USER_MODAL,
  };
}

export function closeGetUserModal(): CloseGetUserModal {
  return {
    type: GetUserActionTypes.CLOSE_GET_USER_MODAL,
  };
}

export function getUserRequest(input: object): GetUserRequest {
  return {
    type: GetUserActionTypes.GET_USER_REQUEST,
    input,
  };
}

export function getUserSucceeded(user: User): GetUserSucceeded {
  return {
    type: GetUserActionTypes.GET_USER_SECCEEDED,
    user,
  };
}

export function getUserFailed(error: string): GetUserFailed {
  return {
    type: GetUserActionTypes.GET_USER_FAILED,
    error,
  };
}
